import './polyfill'
import 'bootstrap/dist/css/bootstrap.min.css'
import './styling/global.css'
import 'videojs-mux'
import '@videojs/http-streaming/dist/videojs-http-streaming'
import 'react-multi-carousel/lib/styles.css'

import * as serviceWorker from './serviceWorker'

import store, { persistor } from './redux/store'

import { BreakpointProvider } from 'react-socks'
import { BrowserRouter } from 'react-router-dom'
import { MuiThemeProvider } from '@material-ui/core/styles'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'
import React from 'react'
import ReactDOM from 'react-dom'
import { App } from './app'
import { cadenzaBaseTheme } from 'styling/theme'
import setupSentry from './setupSentry'
import smoothscroll from 'smoothscroll-polyfill'
import setupAxios from './libs/web-client/utils/axios/src'
import { environment } from './environment'
import {
    Auth0Provider,
    getCallbacks as getAuth0Callbacks,
    configure as configureAuth0,
} from './libs/web-client/utils/auth0/src'

setupAxios({
    environment,
    getAuth0Callbacks,
})

setupSentry()

configureAuth0({ environment })

smoothscroll.polyfill()

ReactDOM.render(
    <MuiThemeProvider theme={cadenzaBaseTheme}>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <BreakpointProvider>
                    <BrowserRouter>
                        <Auth0Provider
                            domain={environment.auth0.domain}
                            clientId={environment.auth0.clientId}
                            redirectUri={window.location.origin}
                            audience={environment.auth0.apiId}
                        >
                            <App />
                        </Auth0Provider>
                    </BrowserRouter>
                </BreakpointProvider>
            </PersistGate>
        </Provider>
    </MuiThemeProvider>,

    document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
